import {Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input} from '@angular/core';
import {UserModel} from '../../../../models/user.model';
import {Observable} from 'rxjs/Observable';
import {AuthorModel} from '../../../../models/author.model';

@Component({
    selector: 'app-author-form-part',
    templateUrl: './author-form-part.component.html',
    styleUrls: ['./author-form-part.component.scss']
})
export class AuthorFormPartComponent implements OnInit {

    @Output('onValidChange')
    onValidChange = new EventEmitter<boolean>();
    @Output('onAuthorChange')
    onAuthorChange = new EventEmitter<AuthorModel[]>();


    @ViewChild('searchInput') searchInput;
    user = new UserModel();
    @Input()
    authors: AuthorModel[] = [];

    constructor() {
    }

    ngOnInit() {
    }

    userSubmited($event: UserModel) {
        const author = AuthorModel.createFromUserModel($event);
        this.authors.push(author);
        this.user = new UserModel();
        this.searchInput.onCloseButton();
        this.onValidChange.emit(this.authors.length !== 0);
        this.onAuthorChange.emit(this.authors);

    }

    onUserDelete(author: AuthorModel, $event) {
        this.authors = this.authors.filter(obj => obj !== author);
        this.onValidChange.emit(this.authors.length !== 0);
        this.onAuthorChange.emit(this.authors);
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/base-publication-form-part/author-form-part/author-form-part.component.ts